import CryptoJS from "crypto-js";
import { TokenService, UserService } from "../../services/storage.service";

const initialState = {
  auth: '',
  user: '',
  token: '',
  role_id: '',
  loggedIn: false,
  redux_loader: false,
  server_errors: '',
};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        loggingIn: true,
        auth: action.auth,
        token: action.token,
        user: action.user
        //role_id: action.role_id,
      };
    case 'UPDATE_LOADER_STATE':
      state.redux_loader = action.loader_state;
      return {
        ...state
      };

    case 'SERVER_ERRORS':
      state.server_errors = action.server_errors;
      return {
        ...state
      };

    case 'CITIES_LIST':
      state.cities_list = action.cities_list;
      return {
        ...state
      };

    case 'COUNTRY_STATES_LIST':
      state.country_states_list = action.country_states_list;
      return {
        ...state
      };

    case 'ALLOWED_COUNTRY_FOR_CHEQUE':
      state.allowed_country_for_cheque = action.allowed_country_for_cheque;
      return {
        ...state
      };

    case 'GIFTAID_COUNTRY_STATES_LIST':
      state.giftaid_country_states_list = action.giftaid_country_states_list;
      return {
        ...state
      };

    case 'GIFTAID_CITIES_LIST':
      state.giftaid_cities_list = action.giftaid_cities_list;
      return {
        ...state
      };

    case 'UPDATE_PRIVACY_POLICY':
      state.update_privacy_policy = action.update_privacy_policy;
      return {
        ...state
      };

    case 'CURRENT_USER':
      return {
        ...state,
        current_user: action.current_user
      };
    case 'USER_STATS':
      return {
        ...state,
        user_stats: action.user_stats
      };
    case 'LOGOUT_SUCCESS':
      return {
        auth: false
      };
    case 'LOGIN_RESPONSE':
      return {
        ...state,
        login_result: action.login_result
      };
    default:

      state.user = UserService.userExist() ? UserService.getUser() : "";
      state.token = TokenService.tokenExist() ? TokenService.getToken() : "";

      return state
  }
}